// extracted by mini-css-extract-plugin
export var ani = "x_bk";
export var ani2 = "x_bp";
export var animationMarquee = "x_c";
export var b = "x_Y";
export var border = "x_Z";
export var container = "x_b";
export var text = "x_S";